import Select from 'react-select';
import AsyncSelect from 'react-select/async';
import styled, { css } from 'styled-components';
import { styles } from '../../molecules/Input/Input.styles';

const Styles = css`
  /* z-index: 9999; */
  position: ${({ $staticPosition }) => ($staticPosition ? 'static !important' : 'relative')};
  .react-select__control {
    ${styles}
    color: var(--primary);
    min-height: inherit;
    padding-top: 0;
    padding-bottom: 0;
    padding-left: 20px;
    padding-right: 20px;
    font-size: 14px;
    border-color: ${({ error }) => error && 'var(--danger) !important'};
    box-shadow: none;
    ${({ $gray }) =>
    $gray &&
    css`
        background: var(--gray-4);
      `}
    &:hover {
      /* border-color: var(--light); */
      border-color: #dedede;
    }
    &.react-select__control--is-focused,
    &.react-select__control--menu-is-open {
      border-color: var(--primary);
      font-size: 14px;
    }
  }
  .react-select__placeholder {
    color: var(--light-gray);
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
    max-width: calc(100% - 8px);
  }
  .react-select__value-container {
    padding-left: 0;
    padding-right: 0;
  }
  .react-select__menu {
    box-shadow: 3px 18px 44px rgba(176, 183, 195, 0.28);
    border-radius: 8px;
    border: 1px solid var(--light);
    z-index: 999;
  }

  ${({ disabled }) =>
    disabled &&
    css`
      opacity: 0.6;
      pointer-events: none;
    `}

  .react-select__option {
    font-size: 12px;
    &:active {
      color: var(--primary);
      background: linear-gradient(90deg, rgba(39, 131, 236, 0.1) 0%, rgba(30, 220, 227, 0.1) 100%);
    }
  }
  .react-select__option--is-focused {
    color: var(--primary);
    background: linear-gradient(90deg, rgba(39, 131, 236, 0.1) 0%, rgba(30, 220, 227, 0.1) 100%);
  }
  .react-select__option--is-selected {
    color: var(--primary);
    background: linear-gradient(90deg, rgba(39, 131, 236, 0.1) 0%, rgba(30, 220, 227, 0.1) 100%);
  }
  .react-select__indicator,
  .react-select__dropdown-indicator,
  .css-1xc3v61-indicatorContainer {
    color: var(--text-color) !important;
    svg {
      width: 16px;
    }
  }

  ${({ isMulti }) =>
    isMulti &&
    css`
      .react-select__control {
        height: auto;
        min-height: 40px;
        font-size: 14px;
      }
      .react-select__option {
        position: relative;

        &.react-select__option--is-selected {
          background: none;
          color: #0f2546;
          &:after {
            opacity: 1;
            visibility: visible;
          }
          &.react-select__option--is-focused {
            background: var(--light-secondary);
          }
        }
      }
      .react-select__multi-value {
        background: rgba(53, 91, 133, 0.1);
        /* font-size: 12px; */
        line-height: 12px;
        border-radius: 60px;
        color: var(--primary);
      }
      .react-select__multi-value__label {
        color: var(--primary);
      }
    `}
`;

export const StyledSelect = styled(Select)`
  ${Styles}
`;

export const StyledSelectAsync = styled(AsyncSelect)`
  ${Styles}
`;
